import { PUC_EDM_NETWORK } from './pucEdm';

/**
 * Read-only general-alpha capture, integration network 231934043, 19 October 2026.
 * Keep the historical PUC EDM fixture separate: its topology is not this network.
 */
export const TEST_PUC_NETWORK = {
    ...PUC_EDM_NETWORK,
    eid: '231934043',
    name: 'test PUC',
    timezone: 'Europe/Paris',
    studyPhase: 'Construction',
    contract: '',
    owner: 'Erika DAL MONTE',
    owners: ['Erika Dal Monte – Technical account - 2', 'Cecile ONNO'],
    readers: ['ON'],
    editors: [],
    createdAt: '19-06-2025 à 15:41:51',
    updatedAt: '06-10-2026 à 20:48:44',
};

/** Only values visible in the captured production views; not a migrated PUC EDM model. */
export const TEST_PUC_PRODUCTION = {
    sites: [
        { name: 'Chaufferie biomasse', departure: 'dkidd', units: ['Chaudière 2', 'TEST V2', 'test'], pumps: ['Pompes distrib biomasse'], pumpGroup: 'Collector chaufferie biomasse pumps group jefait50' },
        { name: 'Chaufferie gaz', departure: 'hello1', units: ['Chaudière gaz', 'test dmeo'], pumps: ['Pompes existantes'], pumpGroup: 'Pompes Sud' },
    ],
    units: [
        { site: 'Chaufferie gaz', name: 'Chaudière gaz', kind: 'boiler' as const, priority: 22, fuelContract: null, defaultPrice: '', pMin: 0, pMax: 55, efficiencyAtPMin: 1, efficiencyAtPMax: 1, rampUp: null, rampDown: null },
        { site: 'Chaufferie biomasse', name: 'Chaudière 2', kind: 'boiler' as const, priority: 7, fuelContract: 'Contrat gaz', defaultPrice: '1', pMin: 0, pMax: 15, efficiencyAtPMin: 1, efficiencyAtPMax: 1, rampUp: null, rampDown: null },
    ],
    pumps: [
        { site: 'Chaufferie biomasse', pumpGroup: 'Collector chaufferie biomasse pumps group jefait50', pump: 'Pompes distrib biomasse', type: 'Variable' as const, flow: '0 0.1 999.9 1000', deltaP: '10 10 0', powerContract: 'test' },
        { site: 'Chaufferie gaz', pumpGroup: 'Pompes Sud', pump: 'Pompes existantes', type: 'Variable' as const, flow: '0 1 2269.65 2292.57', deltaP: '8 8 1e-07', powerContract: '' },
    ],
    fuelContracts: [
        { name: 'Contrat gaz', linkedUnits: 3, fixedPrice: 1, variablePrice: null, calorificValue: 3600000000, description: '-', renewableShare: {}, co2: null },
        { name: 'Centrale_Default', linkedUnits: 2, fixedPrice: 1, variablePrice: null, calorificValue: 3600000000, description: '-', renewableShare: {}, co2: null },
    ],
    powerContracts: [
        { name: 'test', linkedSites: 0, linkedUnits: 1, linkedPumpGroups: 1, fixedPrice: 65, variablePrice: null, description: '-' },
    ],
    renewableThresholds: [
        { name: 'RE2020', min: 0.14, max: 0.02 },
    ],
};
